import type {
  GetAppetiteCountQuery,
  Risk_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAppetiteCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type AppetiteCountArgs = {
  // Resolved entity-filter selection — drives the tRPC path. Empty/absent ⇒
  // no entity filter.
  entityIds?: string[];
  // The equivalent Hasura bool_exp (over the risk table, incl. the
  // appetites>=1 predicate) — drives the GraphQL fallback so the flag-gated
  // twin counts identically. Built by useEntityWhereFilter.
  where?: Risk_Bool_Exp;
};

// The appetite badge counts the risk table (risks with >=1 appetite), so the
// tRPC procedure lives on the risk router (frontend.risk.appetiteCount) and
// the response maps to risk_aggregate.
export const useGetAppetiteCount = createQueryHook<
  AppetiteCountArgs,
  number,
  GetAppetiteCountQuery
>({
  trpcQueryOptions: (trpc, queryArgs) =>
    trpc.frontend.risk.appetiteCount.queryOptions({
      entityIds: queryArgs?.entityIds,
    }),
  // Pass the count straight through (not `data ?? 0`): the factory surfaces
  // undefined while loading, so a genuine 0 must stay 0.
  mapTrpcDataToGraphQL: (data) => ({
    risk_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  graphqlDocument: GetAppetiteCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
